import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditBranch() {
  const [Branch_data, setBranch_data] = useState([]);
  let { id } = useParams();
  const classes = useStyles();
  const EmpId = localStorage.getItem("EmpId");
  const [company_data, setCompany_data] = useState([]);
  const [company_id, setCompanyId] = useState("");
  const [value, setValue] = useState("1");
  //Warehouse UseState
  const [Warehouse, setWarehouse] = useState();
  const [FoundStatus, setFoundStatus] = useState(false);
  //Add Warehouse UseState
  const [warehouse_name, setWarehouse_name] = useState("");
  const [warehouse_remark, setWarehouse_remark] = useState("");
  const [warehose_no, setWarehose_no] = useState("");
  const data_params = { id: id };
  const data_warehouse_params = { branchId: id };
  const [warehose_bay, setWarehose_bay] = useState(1);
  const [warehose_row, setWarehose_row] = useState(1);
  const [warehose_tires, setWarehose_tires] = useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleDisable = (index) => {
    const _warehouse = Warehouse.map((item, index2) =>
      index === index2 ? { ...item, disabled: !item.disabled } : item
    );
    setWarehouse(_warehouse);
    // console.log(props);
    // setDisableForm(true);
  };

  const confirmAddWarehouse = () => {
    if (
      warehouse_name !== "" &&
      warehouse_remark !== "" &&
      warehose_no !== ""
    ) {
      setOpen(false);
      const MySwal = withReactContent(Swal);
      MySwal.fire({
        title: "Confirm Save?",
        text: "I agree to save the data!",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes !",
      }).then((result) => {
        if (result.isConfirmed) {
          const data = {
            branchId: id,
            name: warehouse_name,
            remark: warehouse_remark,
            no: warehose_no,
            status: 1,
            createId: EmpId,
            bay: warehose_bay,
            row: warehose_row,
            tires: warehose_tires,
          };

          api
            .post("api/branch/warehouse/create", data)
            .then((respose) => {
              MySwal.fire("Success!", "Warehouse Saved Success.", "success");
              setValue("2");
              getDataWarehouse();

              // console.log(respose);
            })
            .catch((err) => {
              MySwal.fire(
                "Error!",
                "Can't Saved Warehouse Please Check Data.",
                "error"
              );
              setValue("2");
              console.log(err);
            });
        }
      });
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };

  const getDataWarehouse = async () => {
    try {
      const data = await api
        .post("api/branch/warehouse/list", data_warehouse_params)
        .then((response) => {
          if (response.data.length !== 0) {
            setWarehouse(response.data);
            setFoundStatus(true);
          } else {
            setFoundStatus(false);
          }
        })
        .catch((err) => {
          setFoundStatus(false);
          console.log(err);
        });
    } catch (e) {
      setFoundStatus(false);
      console.log(e);
    }
  };

  //fetch Company Data
  const getCompanyData = async () => {
    try {
      const data = await api.get("api/master/company");
      setCompany_data(data?.data?.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Data

  const getData = async () => {
    try {
      const data = await api
        .post("api/branch/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            setBranch_data(response.data);
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Branch");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // console.log(id);
    // GET request using axios inside useEffect React hook
    getData();
    getCompanyData();
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  useEffect(() => {
    if (value === "1") {
      getData();
    }
    if (value === "2") {
      getDataWarehouse();
    }
  }, [value]);

  const history = useHistory();
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          สาขา
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Branch
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Edit Branch
            </Typography>
          </Grid>
        </Grid>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              variant="scrollable"
              scrollButtons="auto"
              onChange={handleChange}
              TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
            >
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="Infomation"
                value="1"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="Warehouse"
                value="2"
              />
            </TabList>
          </Box>
          <TabPanel value="1">
          
          
            <Formik
              enableReinitialize
              initialValues={{
                company_id: Branch_data.CompanyId ? Branch_data.CompanyId : "",
                company_name: Branch_data.CompanyId
                  ? company_data?.find(
                      (x) => x?.CompanyId === Branch_data.CompanyId
                    )?.CompanyName
                  : "",
                branch_no: Branch_data.BranchNo,
                branch_name: Branch_data.BranchName,
                address: Branch_data.BranchAddress,
                telephone: Branch_data.BranchMobile,
                fax: Branch_data.BranchFax,
                remark: Branch_data.Remark,
                branch_status: Branch_data.Status
                  ? Branch_data.Status === true
                    ? 1
                    : 0
                  : 0,
              }}
              validate={(values) => {
                const errors = {};
                if (!values.branch_no || values.branch_no === "") {
                  errors.branch_no = "Required";
                }
                if (!values.branch_name || values.branch_name === "") {
                  errors.branch_name = "Required";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  const data = {
                    id: Branch_data.BranchId,
                    companyId: Branch_data.CompanyId,
                    no: values.branch_no,

                    name: values.branch_name,
                    address: values.address,
                    phone: values.telephone,
                    fax: values.fax,
                    remark: values.remark,
                    status: values.branch_status,
                    ModId: EmpId,
                  };

                  api
                    .post("api/branch/update", data)
                    .then((respose) => {
                      const MySwal = withReactContent(Swal);

                      MySwal.fire({
                        icon: "success",
                        didOpen: () => {
                          MySwal.clickConfirm();
                        },
                      }).then(() => {
                        return MySwal.fire(
                          "สำเร็จ!",
                          "แก้ไขสาขาสำเร็จ !",
                          "success"
                        ).then((result) => {
                          if (result.isConfirmed) {
                            history.push("/Setting/Branch");
                          }
                        });
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                    });

                  setSubmitting(false);
                }, 400);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <div style={{ display: "flex" }}>
                        <TextField
                          name="company_name"
                          label="Company"
                          variant="outlined"
                          placeholder="Company"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={values.company_name}
                          fullWidth
                          disabled
                        />

                        <TextField
                          name="branch_no"
                          label="Branch No"
                          variant="outlined"
                          placeholder="Branch No"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={values.branch_no}
                          disabled
                        />
                        {errors.branch_no &&
                          touched.branch_no &&
                          errors.branch_no}
                        <FormControl style={{ width: "25%", marginRight: 5 }}>
                          <InputLabel id="select_status-label">
                            Status
                          </InputLabel>
                          <Select
                            name="branch_status"
                            id="branch_status"
                            value={values.branch_status}
                            label="Status"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <MenuItem value={1}>Active</MenuItem>
                            <MenuItem value={0}>InActive</MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="branch_name"
                          label="Branch Name"
                          variant="outlined"
                          placeholder="Branch Name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={values.branch_name}
                          required
                          classes={{
                            root: !values.branch_name
                              ? classes.customOutline
                              : null,
                          }}
                        />
                        {/* {errors.branch_name &&
                          touched.branch_name &&
                          errors.branch_name} */}
                        <TextField
                          name="telephone"
                          label="Telephone"
                          variant="outlined"
                          placeholder="Telephone"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={values.telephone}
                        />
                        {errors.telephone &&
                          touched.telephone &&
                          errors.telephone}
                        <TextField
                          name="fax"
                          label="Fax"
                          variant="outlined"
                          placeholder="Fax"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={values.fax}
                        />
                        {errors.fax && touched.fax && errors.fax}
                      </div>
                      <div style={{ marginTop: 10 }}>
                        <TextField
                          name="address"
                          label="Address"
                          variant="outlined"
                          placeholder="Address"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          InputLabelProps={{ shrink: true }}
                          value={values.address}
                          fullWidth
                        />
                        {errors.address && touched.address && errors.address}
                      </div>

                      <div style={{ marginTop: 10, marginBottom: 10 }}>
                        <TextField
                          fullWidth
                          rows={3}
                          multiline={true}
                          label="Remark"
                          placeholder="Remark"
                          InputLabelProps={{ shrink: true }}
                          name="remark"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.remark}
                        />
                        {errors.remark && touched.remark && errors.remark}
                      </div>
                    </Grid>
                  </Grid>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={history.goBack}
                  >
                    back
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting && <CircularProgress size={22} />}
                    {!isSubmitting && "SAVE"}
                  </Button>
                </form>
              )}
            </Formik>
          </TabPanel>
          <TabPanel value="2">
            <div style={{ display: "flex", float: "right" }}>
              <Button
                style={{
                  backgroundColor: "#80C340",
                  color: "white",
                  textTransform: "none",
                }}
                onClick={handleClickOpen}
              >
                <span className="material-icons-outlined">add</span>
                Add Warehouse
              </Button>
            </div>
            <div>
              {!FoundStatus && (
                <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                  ไม่พบข้อมูล Warehouse
                </h6>
              )}

              {FoundStatus &&
                Warehouse.map((item, i) => (
                  <div key={i}>
                    {/* <h4
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Factory #{i + 1}
                    </h4> */}

                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        warehouse_id: item.WarehouseId,
                        branch_id: item.BranchId,
                        warehouse_name: item.WarehouseName,
                        warehouse_no: item.WarehouseNo,
                        warehouse_remark: item.Remark,
                        warehouse_status: item.Status
                          ? item.Status === true
                            ? 1
                            : 0
                          : 0,
                        warehose_bay: item?.CyBay,
                        warehose_row: item?.CyRows,
                        warehose_tires: item?.CyTires,
                      }}
                      validate={(values) => {
                        const errors = {};
                        if (
                          !values.warehouse_name ||
                          values.warehouse_name === ""
                        ) {
                          errors.warehouse_name = "Required";
                        }
                        return errors;
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                          const MySwal = withReactContent(Swal);
                          MySwal.fire({
                            title: "Confirm Save?",
                            text: "I agree to save the data!",
                            icon: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes !",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              const data = {
                                id: values.warehouse_id,
                                branchId: values.branch_id,
                                name: values.warehouse_name,
                                remark: values.warehouse_remark,
                                no: values.warehouse_no,
                                status: values.warehouse_status,
                                ModId: EmpId,
                                bay: values.warehose_bay,
                                row: values.warehose_row,
                                tires: values.warehose_tires,
                              };

                              api
                                .post("api/branch/warehouse/update", data)
                                .then((respose) => {
                                  MySwal.fire(
                                    "Success!",
                                    "Edit  Success.",
                                    "success"
                                  );

                                  setValue("2");
                                  getDataWarehouse();

                                  // console.log(respose);
                                })
                                .catch((err) => {
                                  MySwal.fire(
                                    "Error!",
                                    "Can't Saved Factory Please Check Data.",
                                    "error"
                                  );
                                  setValue("2");
                                  console.log(err);
                                });
                            }
                          });

                          setSubmitting(false);
                        }, 400);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,

                        /* and other goodies */
                      }) => (
                        <form
                          onSubmit={handleSubmit}
                          style={{ margin: "20px" }}
                        >
                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <div style={{ display: "flex", marginTop: 10 }}>
                                <TextField
                                  name="warehouse_name"
                                  label="Warehouse Name"
                                  variant="outlined"
                                  placeholder="Warehouse Name"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "50%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.warehouse_name}
                                  disabled={!item?.disabled}
                                />
                                {errors.warehouse_name &&
                                  touched.warehouse_name &&
                                  errors.warehouse_name}
                                <TextField
                                  name="warehouse_no"
                                  label="Warehouse No."
                                  variant="outlined"
                                  placeholder="Warehouse No."
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "25%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.warehouse_no}
                                  disabled={!item?.disabled}
                                />
                                {errors.warehouse_no &&
                                  touched.warehouse_no &&
                                  errors.warehouse_no}
                                <FormControl
                                  style={{
                                    width: "25%",
                                  }}
                                >
                                  <InputLabel id="select_status-label">
                                    Status
                                  </InputLabel>
                                  <Select
                                    name="warehouse_status"
                                    value={values.warehouse_status}
                                    label="Status"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={!item?.disabled}
                                  >
                                    <MenuItem value={1}>Active</MenuItem>
                                    <MenuItem value={0}>InActive</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                              <div style={{ display: "flex", marginTop: 10 }}>
                                <TextField
                                  name="warehose_bay"
                                  label="Bay"
                                  variant="outlined"
                                  placeholder="Bay"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "50%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.warehose_bay}
                                  disabled={!item?.disabled}
                                />
                                {errors.warehose_bay &&
                                  touched.warehose_bay &&
                                  errors.warehose_bay}
                                <TextField
                                  name="warehose_row"
                                  label="Row"
                                  variant="outlined"
                                  placeholder="Row"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "25%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.warehose_row}
                                  disabled={!item?.disabled}
                                />
                                {errors.warehose_row &&
                                  touched.warehose_row &&
                                  errors.warehose_row}
                                <TextField
                                  name="warehose_tires"
                                  label="Tires"
                                  variant="outlined"
                                  placeholder="Tires"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "25%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.warehose_tires}
                                  disabled={!item?.disabled}
                                />
                                {errors.warehose_tires &&
                                  touched.warehose_tires &&
                                  errors.warehose_tires}
                              </div>
                              <div style={{ display: "flex", marginTop: 10 }}>
                                <TextField
                                  name="warehouse_remark"
                                  label="Warehouse Remark"
                                  variant="outlined"
                                  placeholder="Warehouse Remark"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "75%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.warehouse_remark}
                                  disabled={!item?.disabled}
                                />
                                {errors.warehouse_remark &&
                                  touched.warehouse_remark &&
                                  errors.warehouse_remark}

                                <Button
                                  type="button"
                                  variant="contained"
                                  size="small"
                                  style={{
                                    color: "white",
                                    borderColor: "#FFA101",
                                    background: "#FFA101",
                                    marginRight: "10px",
                                    textTransform: "none",
                                  }}
                                  onClick={() => handleDisable(i)}
                                >
                                  Edit
                                </Button>
                                {item?.disabled && (
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                      background: "#80c340",
                                      borderColor: "#80c340",
                                      marginRight: "10px",
                                      textTransform: "none",
                                    }}
                                    disabled={isSubmitting}
                                  >
                                    {isSubmitting && (
                                      <CircularProgress size={22} />
                                    )}
                                    {!isSubmitting && "SAVE"}
                                  </Button>
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </form>
                      )}
                    </Formik>
                    <hr />
                  </div>
                ))}
            </div>
          </TabPanel>
        </TabContext>
      </Card>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Warehose</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please complete the information. and check before confirming .
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Warehose Name."
            onChange={(e) => setWarehouse_name(e.target.value)}
            value={warehouse_name}
            fullWidth
            variant="standard"
          />
          <TextField
            margin="dense"
            label="Warehouse No."
            fullWidth
            variant="standard"
            onChange={(e) => setWarehose_no(e.target.value)}
            value={warehose_no}
          />

          <TextField
            margin="dense"
            label="Remark"
            fullWidth
            variant="standard"
            onChange={(e) => setWarehouse_remark(e.target.value)}
            value={warehouse_remark}
          />
          <div style={{ display: "flex" }}>
            <TextField
              margin="dense"
              label="Bay"
              fullWidth
              variant="standard"
              onChange={(e) => setWarehose_bay(e.target.value)}
              value={warehose_bay}
            />
            <TextField
              margin="dense"
              label="Row"
              fullWidth
              variant="standard"
              onChange={(e) => setWarehose_row(e.target.value)}
              value={warehose_row}
            />
            <TextField
              margin="dense"
              label="Tires"
              fullWidth
              variant="standard"
              onChange={(e) => setWarehose_tires(e.target.value)}
              value={warehose_tires}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={confirmAddWarehouse}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
